const palette = {
  misc: {
    darkSurface: '#041E44',
    purple: '#9E68AF',
    green: '#0A8043',
    primaryAccent: '#00B0ED',
    darkBrown: '#7C7666',
    orangeBrown: '#926D00',
    darkGreen: '#15692A',
    lightGreen: '#D4F7DC'
  },
  primary: {
    dark: '#926D00',
    main: '#FDC10E',
    shade: '#B3CDFF',
    light: '#FFF9E6'
  },
  secondary: {
    main: '#A7A9BC',
    light: '#E7E7ED'
  },
  border: {
    primary: '#458FFF',
    error: '#F48989',
    success: '#54CA75',
    tableBorder: '#EDEDED',
    default: '#CDCED9',
    light: '#EEEDF2'
  },
  success: {
    main: '#5ACA75',
    light: '#EDF9F0',
    dark: '#287D3C'
  },
  info: {
    main: '#458FFF',
    light: '#F0F5FF',
    dark: '#0050C8'
  },
  warning: {
    main: '#E0B878',
    light: '#FFF5EA',
    dark: '#B98900'
  },
  error: {
    main: '#F48989',
    light: '#FEEFEF',
    dark: '#DA1414'
  },
  background: {
    secondary: '#F7F8F9',
    tableHeader: '#F5F5F5',
    dark: '#161100',
    darkInput: '#F5F7FA'
  },
  text: {
    black: '#000',
    main: '#393A4A',
    secondary: '#6B6C7E',
    title: '#272833',
    btnText: '#312D22',
    light: '#F5F7FA',
    link: '#BC8D00',
    primary: '#393A4A',
    dark: '#1E0A3C',
    lightGrey: '#9DA0A7'
  },
  grey: {
    border: '#E5E5EA',
    background: '#E5E5E5',
    light: '#E5E5E5',
    dark: '#D9D9D9'
  }
};

export default palette;
